import { useCallback } from "react";

import { formsApi } from "./api";

export const useAssetUpload = () => {
  const { post: getUploadUrl } = formsApi.asset();

  const uploadAsset = useCallback(
    async ({
      key,
      file,
      token,
    }: {
      key: string;
      file: File;
      token: string;
    }): Promise<string> => {
      const assetResult = await getUploadUrl({
        body: {
          key,
          destination: "Asset",
        },
        token,
      });

      if (!assetResult?.uploadUrl) {
        throw new Error("Failed to get upload URL");
      }

      const uploadResponse = await fetch(assetResult.uploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (!uploadResponse.ok) {
        throw new Error("Failed to upload file");
      }

      if (!assetResult.downloadUrl) {
        throw new Error("Failed to get download URL");
      }

      return assetResult.downloadUrl;
    },
    [getUploadUrl],
  );

  return { uploadAsset };
};
